import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface GoogleReviewsData {
  rating: number;
  reviewCount: number;
  reviews: Array<{
    author: string;
    rating: number;
    text: string;
    time: string | null;
    relativeTime: string;
  }>;
  fetchedAt: string;
}

export function useGoogleReviews() {
  return useQuery<GoogleReviewsData | null>({
    queryKey: ["google-reviews"],
    queryFn: async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "google_reviews")
        .maybeSingle();
      if (data?.value) {
        try {
          return JSON.parse(data.value) as GoogleReviewsData;
        } catch {
          return null;
        }
      }
      return null;
    },
    staleTime: 1000 * 60 * 10,
  });
}
